import { alpha } from '@mui/material/styles'

export const MuiBackdrop = {
  styleOverrides: {
    root: {
      backgroundColor: alpha('#1D2939', 0.8)
    },
    invisible: {
      background: 'transparent'
    }
  }
}
